import React from 'react'
import PropTypes from 'prop-types'

export const GGRadio = ({
  label,
  value,
  selected,
  onChange,
  name,
  disabled = false,
  className,
}) => {
  const classes = [
    'gg-radio',
    disabled && 'gg-radio--disabled',
    className,
  ].filter(Boolean).join(' ')

  return (
    <label className={classes}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={selected === value}
        disabled={disabled}
        onChange={disabled ? undefined : () => onChange(value)}
      />
      <span className="gg-radio__dot" aria-hidden/>
      {label && <span className="gg-radio__label">{label}</span>}
    </label>
  )
}

GGRadio.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  selected: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}
